import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Classes, Divider, Icon } from '@blueprintjs/core';
import Pages from './Pages';

export default class SroFilterMenuDialog extends Component {
  render() {
    return (
      <div className={`${Classes.DIALOG_BODY} container mx-auto py-4`}>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Filter Settings
        </h3>

        <Divider />

        <div className="row mb-4">
          {Pages.FilterSettings.sort((x, y) =>
            x.Name.toLowerCase() > y.Name.toLowerCase() ? 1 : -1
          ).map((Link, LinkIndex) => (
            <div className="col-4 col-sm-3 col-md-2" key={LinkIndex}>
              <NavLink
                to={Link.To}
                className="bp3-button bp3-fill bp3-large bp3-minimal text-center d-block"
                disabled={Link.Disabled}
              >
                <Icon icon={Link.Icon} iconSize={30} className="m-0 mt-3" />
                <span
                  className="mt-2"
                  style={{ display: 'block', height: '50px' }}
                >
                  {Link.Name}
                </span>
              </NavLink>
            </div>
          ))}
        </div>

        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Web Settings
        </h3>

        <Divider />

        <div className="row mb-4">
          {Pages.WebSettings.map((Link, LinkIndex) => (
            <div className="col-4 col-sm-3 col-md-2" key={LinkIndex}>
              <NavLink
                to={Link.To}
                className="bp3-button bp3-fill bp3-large bp3-minimal text-center d-block"
                disabled={Link.Disabled}
              >
                <Icon icon={Link.Icon} iconSize={30} className="m-0 mt-3" />
                <span
                  className="mt-2"
                  style={{ display: 'block', height: '50px' }}
                >
                  {Link.Name}
                </span>
              </NavLink>
            </div>
          ))}
        </div>

        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Server Settings
        </h3>

        <Divider />

        <div className="row mb-4">
          {Pages.ServerSettings.map((Link, LinkIndex) => (
            <div className="col-4 col-sm-3 col-md-2" key={LinkIndex}>
              <NavLink
                to={Link.To}
                className="bp3-button bp3-fill bp3-large bp3-minimal text-center d-block"
                disabled={Link.Disabled}
              >
                <Icon icon={Link.Icon} iconSize={30} className="m-0 mt-3" />
                <span
                  className="mt-2"
                  style={{ display: 'block', height: '50px' }}
                >
                  {Link.Name}
                </span>
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
